import { motion } from "framer-motion";
import { Mail, Cloud, Building2, Shield } from "lucide-react";

const integrations = [
  { name: "Gmail", icon: Mail },
  { name: "Dropbox", icon: Cloud },
  { name: "50+ organismes", icon: Building2 },
];

const stats = [
  { value: "10 000+", label: "documents classés" },
  { value: "3 sec", label: "pour trouver un fichier" },
  { value: "99.9%", label: "de précision OCR" },
];

export const TrustBlock = () => {
  return (
    <section className="py-10 md:py-14 px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="container mx-auto max-w-4xl"
      >
        {/* Stats row */}
        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10 mb-8">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="text-2xl sm:text-3xl font-bold text-foreground mb-1">
                {stat.value}
              </div>
              <div className="text-xs sm:text-sm text-muted-foreground">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>

        {/* Integrations */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex flex-wrap items-center justify-center gap-3 sm:gap-4"
        >
          <span className="text-sm text-muted-foreground mr-2">Connecté à :</span>
          {integrations.map((integration) => {
            const Icon = integration.icon;
            return (
              <div
                key={integration.name}
                className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary/50 border border-border/50 text-sm"
              >
                <Icon className="w-4 h-4 text-primary" />
                <span className="text-foreground/80">{integration.name}</span>
              </div>
            );
          })}
          <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-sm">
            <Shield className="w-4 h-4 text-emerald-500" />
            <span className="text-emerald-700 dark:text-emerald-400">Agréé ACPR</span>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};
